import { BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { DEFAULTS } from '../consts.js';
import InsertPluginIcon from '../icons/InsertPluginIcon.js';
import 'ricos-schema';
import 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  settings,
  disableDownload,
  disableExpand
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || InsertPluginIcon;
  const PluginData = disableDownload !== void 0 ? __spreadProps(__spreadValues({}, DEFAULTS), { disableDownload }) : DEFAULTS;
  const componentData = disableExpand !== void 0 ? __spreadProps(__spreadValues({}, DEFAULTS), { disableExpand }) : PluginData;
  const imageInsertButton = {
    type: BUTTON_TYPES.FILE,
    multi: true,
    name: INSERT_PLUGIN_BUTTONS.IMAGE,
    tooltip: t("ImagePlugin_InsertButton_Tooltip"),
    toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
    getIcon: () => icon,
    componentData
  };
  return [imageInsertButton];
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
